<template>
  <div class="pa-connection-create-pod">
    <div class="pa-create-pod-loading" ref="contentField">
      <transition name="simple-fade-height">
        <div class="header-field" v-if="viewType === 'loading'" ref="headerField">
          <div class="pa-title">ポットの取り寄せ</div>
          <div class="pa-description">
            <p>ポットの取り寄せ中です。しばらくお待ち下さい。</p>
          </div>
        </div>
      </transition>

      <div class="pod-loading-image" :class="loadingImageClass" ref="podImageField">
        <MeltingPodImage />
      </div>

      <transition name="pa-connection-editor-loading-fade">
        <div class="pa-complete" v-if="viewType !== 'loading'">
          <p>ポットの取り寄せが完了しました。</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import MeltingPodImage from '@/components/Parts/PAConnectionManageModal/Images/meltingpod.svg?inlineN'

export default {
  props : {
    viewType : {
      default: 'loading'
    },
  },

  components : {
    MeltingPodImage
  },

  data(){
    return {
      loadingImageClass : {
        'pod-loading-image-complete' : false,
        'pod-loading-image-loading'  : false
      },
    };
  },

  watch : {
    viewType : {
      handler(value){
        switch(value){
          case 'loading':
            this.loadingImageClass['pod-loading-image-loading']  = true;
            this.loadingImageClass['pod-loading-image-complete'] = false;
          break;

          case 'complete':
          default:
            this.loadingImageClass['pod-loading-image-loading']  = false;
            this.loadingImageClass['pod-loading-image-complete'] = true;
          break;
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.simple-fade-height{
  &-enter-active, &-leave-active {
    transition: opacity .2s, height .2s;
  }
  
  &-enter, &-leave-to{
    opacity: 0;
    height: 0;
  }
}

.pa-connection-editor-loading-fade{
  &-enter-active{
    animation: fastFadeIn .5s;
  }

  &-leave-active {
    animation: fastFadeIn .5s reverse;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-connection-create-pod{
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  .pa-create-pod-loading{
    width:98%;
    margin:0 auto;
    margin-top:-1rem;
    border:3px solid #B57D3C;
    background-color: #C8A984;
    color:#7C5E49;
    border-radius: 6px;
    transition: height 0.5s;

    .header-field{
      .pa-title{
        color: #7C5E49;
        border-bottom:2px solid #AE906B;
        text-align: center;
        font-size: 1.4rem;
        line-height: 2.4rem;
        width:95%;
        margin:0 auto;
      }
      
      .pa-description{
        color: #7C5E49;
        width:95%;
        margin:.2rem auto 0;
        font-size:.8rem;
        text-align: center;
      }
    }

    .pod-loading-image{
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      
      svg{
        display:block;
        margin:1rem auto;
        width:5rem;

        path{
          fill:#B08968;
        }
      }

      &-complete{
        transition: width 0.5s;
        transition: height 0.5s;
        transition: fill 0.5s;

        svg{
          path{
            transition: fill 0.5s;
            fill:#8A5D37;
          }
        }
      }

      &-loading{
        animation: heartbeat 5s infinite;
        animation-timing-function:ease-in-out;
      }
    }
    
    .pa-complete{
      font-size:.9rem;
      color: #7C5E49;
      text-align: center;
      padding-bottom:.5rem;
    }
  }
}
</style>